export const SWITCH_CITY_TEXTS = {
  modalTitle: 'Выберите ваш город',
  modalSubtitle: 'От города вылета зависит цена на тур и количество предложений',
  searchPlaceholder: 'Поиск по названию',
  nothingFound: 'Ничего не найдено',
  emptyCity: '—',
} as const;
